import * as React from "react";
import { TextField } from "../textfield/textfield.mjs";
class TextArea extends React.Component {
  constructor(props) {
    var _a;
    super(props);
    this.textarea = null;
    this.hiddenTextarea = null;
    this.onChange = (value) => {
      if (typeof this.props.value === "undefined") {
        this.setState({
          value
        });
      }
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    };
    this.renderHiddenTextArea = () => {
      const hiddenInputRef = (el) => this.hiddenTextarea = el;
      return /* @__PURE__ */ React.createElement("div", { className: "textarea__hidden" }, /* @__PURE__ */ React.createElement("label", { className: "textarea__label--hidden", htmlFor: "".concat(this.props.id, "-hidden"), "aria-hidden": "true" }, this.props.label), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          id: "".concat(this.props.id, "-hidden"),
          className: "textfield__input textarea__input textarea__input--hidden",
          value: this.value,
          ref: hiddenInputRef,
          readOnly: true,
          disabled: true,
          "aria-hidden": "true",
          tabIndex: -1
        }
      ));
    };
    this.resizeHeight = this.resizeHeight.bind(this);
    this.state = {
      minHeight: 0,
      value: (_a = props.defaultValue) != null ? _a : ""
    };
  }
  componentDidMount() {
    this.resizeHeight();
    window.addEventListener("resize", this.resizeHeight);
  }
  componentDidUpdate(prevProps, prevState) {
    const hasStateChanged = typeof this.props.value === "undefined" && prevState.value !== this.state.value;
    const hasPropsChanged = typeof this.props.value !== "undefined" && prevProps.value !== this.props.value;
    if (hasStateChanged || hasPropsChanged) {
      this.resizeHeight();
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeHeight);
  }
  get value() {
    if (this.props.isReadOnly || this.props.isDisabled) {
      return typeof this.props.value !== "undefined" ? this.props.value : this.state.value;
    }
    return this.props.onChange && typeof this.props.value !== "undefined" ? this.props.value : this.state.value;
  }
  resizeHeight() {
    if (this.hiddenTextarea && this.textarea) {
      const textarea = window.getComputedStyle(this.textarea);
      const padding = parseInt(textarea.paddingBottom, 10) + parseInt(textarea.paddingTop, 10);
      const border = parseInt(textarea.borderBottomWidth, 10) + parseInt(textarea.borderTopWidth, 10);
      const lineHeight = parseInt(textarea.lineHeight, 10);
      const maxHeight = this.props.maxLines && padding + border + lineHeight * this.props.maxLines;
      const normalHeight = this.hiddenTextarea.scrollHeight + border;
      const newHeight = this.props.maxLines ? Math.min(maxHeight != null ? maxHeight : 0, normalHeight) : normalHeight;
      this.setState({
        minHeight: newHeight || 0
      });
    }
  }
  BEM() {
    const classArray = ["textarea"];
    if (typeof this.props.maxLines !== "undefined") {
      classArray.push("textarea--max-lines");
    }
    if (this.props.height) {
      classArray.push("textarea--".concat(this.props.height));
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getStyle() {
    return { minHeight: this.state.minHeight };
  }
  render() {
    const inputRef = (el) => this.textarea = el;
    return /* @__PURE__ */ React.createElement(
      TextField,
      {
        ...this.props,
        inputRef,
        isTextarea: true,
        className: this.BEM(),
        inputClass: "textarea__input",
        value: this.value,
        onChange: this.onChange,
        inputStyle: this.getStyle(),
        contentRenderer: this.renderHiddenTextArea
      }
    );
  }
}
export {
  TextArea
};
